// export const url: string = window.location.host.includes('localhost') ? '' : '/avnvm'
export const url = '/avnvm';
